export default "__VITE_ASSET__B86I5FCW__"